<template>
  <div class="passengers">
    <h5 class="passengers__title">Passageiros</h5>

    <div class="passengers__tips">
      <div class="row">
        <div style="width: 30px; height: 30px; background: #ffe317; border-radius: 5px;"></div>
        <div class="q-pt-sm q-pl-xs">- Indica que passageiro ainda não embarcou.</div>
      </div>
      <div class="row q-pt-xs">
        <div style="width: 30px; height: 30px; background: #20c600; border-radius: 5px;"></div>
        <div class="q-pt-sm q-pl-xs">- Indica passageiro já embarcado.</div>
      </div>
    </div>

    <q-page-sticky position="bottom-right" class="z-top" :offset="[18, 18]">
      <q-btn
        v-show="showCameraButtonOnPassengers"
        @click="readBoardingQRCode()"
        size="lg"
        class="bg-positive text-white shadow-16"
        icon="camera_alt"
        round
        v-if="passengers.length"
      />
    </q-page-sticky>

    <div v-if="Array.isArray(passengers) && passengers.length > 0" class="q-pb-md">
      <q-tabs
        v-model="passengerStatus"
        dense
        class="text-black no-shadow"
        left-icon="none"
        right-icon="none"
        no-caps
        indicator-color="transparent"
      >
        <q-tab name="false" label="Não embarcado" icon="info" style="padding: 0 10px" disable>
          <q-badge
            color="black"
            floating
            class="text-bold"
            style="margin-right: 17px; margin-top: -3px;"
          >{{ howManyPassengerStatus(false) }}</q-badge>
        </q-tab>
        <q-tab name="true" label="Já embarcado" icon="how_to_reg" style="padding: 0 10px" disable>
          <q-badge
            color="positive"
            class="text-white text-bold"
            floating
            style="margin-right: 28px; margin-top: -3px;"
          >{{ howManyPassengerStatus(true) }}</q-badge>
        </q-tab>
      </q-tabs>
    </div>

    <div v-show="filterPassengerByStatus().length == 0 && passengerStatus === false">
      <span class="text-bold">Por hora não tem mais passageiros para se embarcar.</span>
    </div>

    <div class="row justify-around">
      <div v-if="mapa.andar_2 && mapa.andar_1">
        Andar 1
        <q-toggle
          v-model="alterarAndar"
          :true-value="trueValue"
          :false-value="falseValue"
          color="blue"
        />Andar 2
      </div>
      <div class="q-pt-xs">
        <q-btn
          no-caps
          label="Listar passageiros"
          size="md"
          color="teal-8"
          unelevated
          class="text-weight-bold"
          @click="dialogListPassengers = true"
        />
      </div>
    </div>

    <div class="onibus" id="onibus">
      <div class="container-volante">
        <svg
          class="volante"
          width="50px"
          height="50px"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          enable-background="new 0 0 100 100"
          xml:space="preserve"
        >
          <circle fill="#000" cx="50" cy="53.571" r="7.915" />
          <path
            fill="#000"
            d="M50,0C22.386,0,0,22.386,0,50c0,27.613,22.386,50,50,50c27.613,0,50-22.387,50-50C100,22.386,77.613,0,50,0z M50,8.163c17.871,0,33.115,11.209,39.11,26.977c-0.064,2.236-0.672,4.801-2.994,5.485c-9.949,3.827-18.259-4.401-36.626-4.656 c-18.368,0.255-26.595,8.483-36.543,4.656c-1.653-0.487-2.425-1.927-2.748-3.523C15.637,20.311,31.396,8.163,50,8.163z M60.969,53.571c0,6.059-4.91,10.97-10.969,10.97s-10.969-4.911-10.969-10.97c0-6.058,4.911-10.969,10.969-10.969 S60.969,47.514,60.969,53.571z M20.902,76.531c-1.285,0.584-2.652,0.082-3.928-0.864c-4.667-5.997-7.744-13.291-8.578-21.258 c1.131-1.159,2.91-1.637,5.371-0.838C19.34,55.379,26.515,73.979,20.902,76.531z M64.898,88.777 c-0.338,0.225-0.583,0.425-0.749,0.601c-4.42,1.59-9.182,2.459-14.149,2.459c-5.637,0-11.011-1.123-15.918-3.143 c-5.617-3.789-3.066-7.098-0.281-11.909c2.806-4.847,15.689-3.315,15.689-3.315s12.965-1.531,15.771,3.315 C68.068,81.633,70.682,84.953,64.898,88.777z M85.326,72.402c-1.847,2.36-4.619,5.253-7.095,4.129 c-5.611-2.552,1.568-21.152,7.141-22.96c3.082-0.998,5.093,0,6.104,1.838C90.677,61.601,88.526,67.364,85.326,72.402z"
          />
        </svg>
      </div>

      <div v-for="(linha, index) in mapaAtual" :key="index" class="linha">
        <div v-for="i in 4" :key="i">
          <span
            v-show="linha['ocupada' + i] === false && linha['embarcado' + i] === false"
            :situacao="`${linha['ocupada' + i]}`"
            :embarcado="`${linha['embarcado' + i]}`"
            :numero="linha['coluna' + i]"
            :semafaro="linha['semafaro' + i]"
            :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
            @click="openBoardingManual(searchSeat(linha['coluna' + i]))"
          >{{ linha["coluna" + i] }}</span>

          <span
            v-show="linha['ocupada' + i] === false && linha['embarcado' + i] === true"
            :situacao="`${linha['ocupada' + i]}`"
            :embarcado="`${linha['embarcado' + i]}`"
            :numero="linha['coluna' + i]"
            :semafaro="linha['semafaro' + i]"
            :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
            @click="openBoardingManual(searchSeat(linha['coluna' + i]))"
          >{{ linha["coluna" + i] }}</span>

          <span
            v-show="linha['ocupada' + i] === true"
            :situacao="`${linha['ocupada' + i]}`"
            :embarcado="`${linha['embarcado' + i]}`"
            :numero="linha['coluna' + i]"
            :semafaro="linha['semafaro' + i]"
            :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
            @click="openBoardingManual(searchSeat(linha['coluna' + i]))"
          >{{ linha["coluna" + i] }}</span>

          <span
            v-show="linha['coluna' + i] === undefined"
            :situacao="`${linha['ocupada' + i]}`"
            :embarcado="`${linha['embarcado' + i]}`"
            :numero="linha['coluna' + i]"
            :semafaro="linha['semafaro' + i]"
            :class="`poltrona ${linha['categoria' + i]} ${linha['tipo' + i]} text-black`"
            @click="openBoardingManual(searchSeat(linha['coluna' + i]))"
          >{{ linha["coluna" + i] }}</span>
        </div>
      </div>
    </div>

    <div class="q-py-xl"></div>

    <q-dialog
      v-model="dialogListPassengers"
      persistent
      :maximized="true"
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <q-card>
        <q-bar class="row q-px-md bg-grey-12" style="height: 50px">
          <div>
            <div class="q-pt-xs">Lista de passageiros</div>
            <div class="passengers__tips">
              <span>- Lista para chamada no embarque</span>
            </div>
          </div>
          <q-space />
          <q-btn dense flat icon="close" color="negative" v-close-popup @click="getMapa()">
            <q-tooltip content-class="bg-white text-primary">Fechar</q-tooltip>
          </q-btn>
        </q-bar>

        <q-card-section>
          <div v-if="Array.isArray(passengers) && passengers.length > 0" class="q-pb-sm">
            <q-tabs
              v-model="passengerStatus"
              dense
              class="text-black no-shadow"
              left-icon="none"
              right-icon="none"
              no-caps
            >
              <q-tab name="false" label="Não embarcado" icon="info" style="padding: 0 10px">
                <q-badge
                  color="black"
                  floating
                  class="text-bold"
                  style="margin-right: 17px; margin-top: -3px;"
                >{{ howManyPassengerStatus(false) }}</q-badge>
              </q-tab>
              <q-tab name="true" label="Já embarcado" icon="how_to_reg" style="padding: 0 10px">
                <q-badge
                  color="positive"
                  class="text-white text-bold"
                  floating
                  style="margin-right: 28px; margin-top: -3px;"
                >
                  {{
                  howManyPassengerStatus(true)
                  }}
                </q-badge>
              </q-tab>
            </q-tabs>
          </div>
          <q-list>
            <q-slide-item
              :class="{ 'passengers--boarded': passenger.boarding_status }"
              :key="passenger.ticket_id"
              class="passengers__ticket card"
              v-for="passenger in filterPassengerByStatus()"
            >
              <q-item class="ticket__container">
                <q-item-section class="ticket__info">
                  <span class="info--highlight text-capitalize">{{ passenger.name.toLowerCase() }}</span>

                  <div class="text-uppercase">
                    <span>{{ passenger.document_type }}:&nbsp;</span>
                    <span class="info--highlight">{{ passenger.document_number }}</span>
                  </div>

                  <div>
                    Poltrona:
                    <span class="info--highlight">{{ passenger.seat }}</span>
                  </div>
                  <div>
                    Destino:
                    <span class="info--highlight">{{ passenger.landing }}</span>
                  </div>
                  <div class="q-mt-sm q-mb-sm" v-if="passenger.luggages"><q-separator /></div>
                  <div class="flex" v-if="passenger.luggages">
                  <i class="ri-suitcase-3-line" style="color: #004923;"></i>
                    Bagagens: <span class="q-ml-sm info--highlight" v-for="(luggage, index) in passenger.luggages" :key="index+'luggages'">
                      Nº {{ luggage.number }},
                    </span>
                  </div>
                </q-item-section>
              </q-item>
            </q-slide-item>
          </q-list>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { SELECTED_SCHEDULE } from "../../variables";
import {
  clearDate,
  getSessionStorage,
  isApp,
  URIToObject,
  removeAcento,
  formatDate,
  getHost
} from "../../functions";
import { mutations, store } from "../../store";

export default {
  name: "Passengers",

  computed: {
    passengers: {
      get() {
        return store.passengers;
      },
      set(value) {
        mutations.setPassengers(value);
      }
    },
    showCameraButtonOnPassengers: {
      get() {
        return store.showCameraButtonOnPassengers;
      },
      set(value) {
        mutations.setShowCameraButtonOnPassengers(value);
      }
    }
  },

  mounted() {
    this.showCameraButtonOnPassengers = true;
  },

  data() {
    return {
      uriBoarding: `${getHost()}/eucaturmobile/boarding/client`,

      schedule: {},

      intervalPassengersUpdate: null,
      passengerStatus: "false",
      sections: [],
      mapa: [],
      mapaAtual: [],
      alterarAndar: "andar_1",
      trueValue: "",
      falseValue: "",
      dialogListPassengers: false
    };
  },

  watch: {
    alterarAndar: function() {
      this.mapaAtual = this.mapa[this.alterarAndar];
    }
  },

  created() {
    this.automaticUpdatePassengers(2);
    this.sections = getSessionStorage("sections");
    this.schedule = getSessionStorage(SELECTED_SCHEDULE);
    this.getPassengers();
    this.getMapa();
  },

  beforeDestroy() {
    clearInterval(this.intervalPassengersUpdate);
  },

  methods: {
    readBoardingQRCode() {
      if (isApp()) {
        const BPE_KEY = "chBPe";

        window.cordova.plugins.barcodeScanner.scan(
          async result => {
            let data = result.text;
            if (!data) {
              return;
            }

            if (data.match(/\?/)) {
              data = data.split("?")[1];
            }

            let obj = URIToObject(data);
            let objJson = JSON.parse(JSON.stringify(obj));
            let travel = store.travel;

            const departure = clearDate(travel.departure);
            const departureTravel = clearDate(travel.departure_travel);

            let urlAPI =
              `${getHost()}/eucaturmobile/boarding/qrcode` +
              `?type=manual&identification=${objJson.identification}` +
              `&code=${travel.boarding_code}&departure=${departure}&departure_travel=${departureTravel}` +
              `&direction=${travel.direction}&line=${travel.line}`;

            if (objJson.type !== "manual") {
              let identification = obj[BPE_KEY] ? obj[BPE_KEY] : null;
              if (!identification) {
                mutations.openAlert({
                  open: true,
                  message: "Erro ao identificar a chave do BPe",
                  status: 500
                });
                return;
              }

              urlAPI =
                `${getHost()}/eucaturmobile/boarding/qrcode` +
                `?type=qrcode&identification=${identification}&code=${travel.boarding_code}` +
                `&departure=${departure}&departure_travel=${departureTravel}` +
                `&direction=${travel.direction}&line=${travel.line}`;
            }

            let ticket = await window.http.get(urlAPI).then(r => r.data);
            this.openBoardingManual(ticket);
            // mutations.setSelectedPassenger(ticket)

            // if (ticket.boarded) {
            //   vaiParaUrl('/sucesso')
            //   return
            // }
            // if (ticket.message) {
            //   vaiParaUrl('/falha')
            //   return
            // }

            // window.http
            //   .post(`${getHost()}/eucaturmobile/boarding/client`, { ticket_id: ticket.ticket_id, boarding_id: travel.id })
            //   .then(r => {
            //     if (r.status === 204) {
            //       notify("Cliente já embarcado", "info");
            //       return;
            //     }
            //     vaiParaUrl("/sucesso");
            //   })
            //   .catch(err => {
            //     console.error(err);
            //     vaiParaUrl("/falha");
            //   });
          },
          error => {
            mutations.openAlert({
              open: true,
              message: error,
              status: 500
            });
          },
          {
            preferFrontCamera: false, // iOS and Android
            showFlipCameraButton: false, // iOS and Android
            showTorchButton: true, // iOS and Android
            torchOn: false, // Android, launch with the torch switched on (if available)
            saveHistory: true, // Android, save scan history (default false)
            prompt: "Leitura de QrCode", // Android
            resultDisplayDuration: 1500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
            formats: "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
            orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
            disableAnimations: true, // iOS
            disableSuccessBeep: false // iOS and Android
          }
        );
      }
    },

    automaticUpdatePassengers(intervalInMinutes) {
      const intervalInMilliseconds = intervalInMinutes * 60 * 1000;
      this.intervalPassengersUpdate = setInterval(() => {
        mutations.openAlert({
          open: true,
          message: "Atualizando lista de passageiros",
          status: 400
        });
        this.getPassengers();
        this.getMapa();
      }, intervalInMilliseconds);
    },

    getPassengers() {
      const departure = clearDate(this.schedule.departure);
      const departureTravel = clearDate(this.schedule.departure_travel);

      const uri =
        `${getHost()}/eucaturmobile/passengers` +
        `?code=${this.schedule.boarding_code}&line=${this.schedule.line}` +
        `&departure=${departure}&departure_travel=${departureTravel}` +
        `&direction=${this.schedule.direction}` +
        `&alternative_code=${this.schedule.boarding_alternative_code}`;

      window.http.get(uri).then(response => {
        if (response.data.message === undefined) {
          this.passengers = response.data;
        }
      });
    },

    openBoardingManual(passenger) {
      mutations.setSelectedPassenger(passenger);
      this.$router.push(`/embarque/passageiro/${passenger.ticket_id}`);
    },

    onLeft(reset, passenger) {
      window.http
        .delete(this.uriBoarding, {
          ticket_id: passenger.ticket_id,
          boarding_id: this.schedule.id
        })
        .then(() => {
          mutations.openAlert({
            open: true,
            message: "Embarque cancelado",
            status: 200
          });
        });

      this.finalize(reset, passenger);
    },

    onRight(reset, passenger) {
      window.http
        .post(this.uriBoarding, {
          ticket_id: passenger.ticket_id,
          boarding_id: this.schedule.id
        })
        .then(() => {
          mutations.openAlert({
            open: true,
            message: "Embarque cancelado",
            status: 200
          });
        });

      this.finalize(reset, passenger);
    },

    finalize(reset, passenger) {
      setTimeout(() => {
        reset();
        // Esse segundo timeout é pra ocultar a renderização da opção da esquerda/direita
        setTimeout(
          () => (passenger.boarding_status = !passenger.boarding_status),
          300
        );
      }, 500);
    },

    howManyPassengerStatus(status) {
      return this.passengers.filter(v => v.boarding_status === status).length;
    },

    filterPassengerByStatus() {
      var status;
      if (this.passengerStatus == "false") {
        status = false;
      } else {
        status = true;
      }
      return this.passengers.filter(v => v.boarding_status == status);
    },

    filterSectional(val) {
      const needle = removeAcento(val.trim().toLowerCase())
        .split(", ")
        .join("-");
      for (let sec of this.sections) {
        if (removeAcento(sec.description.trim().toLowerCase()) === needle) {
          return sec.code;
        }
      }
    },

    async getMapa() {
      const departure = formatDate(this.schedule.departure).substring(10,0);

      const r = await window.http.get(
        `${getHost()}/eucaturmobile/viagens/${this.schedule.travel_id}/mapa?embarque=${this.schedule.boarding_code}&desembarque=${this.schedule.landing_code}&data=${departure}`
      );
      this.mapa = r.data;
      if (r.data.andar_2) {
        if (r.data.andar_1.length > r.data.andar_2.length) {
          this.mapaAtual = r.data.andar_1;
          this.trueValue = "andar_1";
          this.falseValue = "andar_2";
          this.alterarAndar = "andar_1";
        } else {
          this.mapaAtual = r.data.andar_2;
          this.trueValue = "andar_2";
          this.falseValue = "andar_1";
          this.alterarAndar = "andar_2";
        }
      } else {
        this.mapaAtual = r.data.andar_1;
      }
      this.makeMapa();
    },

    makeMapa() {
      if (this.mapa.andar_1) {
        for (let r of this.mapa.andar_1) {
          if (r.coluna1) {
            r.ocupada1 = true;
            let col1 = this.searchSeat(r.coluna1);
            if (col1) {
              r.ocupada1 = false;
              if (col1.boarding_status) {
                r.embarcado1 = true;
              } else {
                r.embarcado1 = false;
              }
            }
          }
          if (r.coluna2) {
            r.ocupada2 = true;
            let col2 = this.searchSeat(r.coluna2);
            if (col2) {
              r.ocupada2 = false;
              if (col2.boarding_status) {
                r.embarcado2 = true;
              } else {
                r.embarcado2 = false;
              }
            }
          }
          if (r.coluna3) {
            r.ocupada3 = true;
            let col3 = this.searchSeat(r.coluna3);
            if (col3) {
              r.ocupada3 = false;
              if (col3.boarding_status) {
                r.embarcado3 = true;
              } else {
                r.embarcado3 = false;
              }
            }
          }
          if (r.coluna4) {
            r.ocupada4 = true;
            let col4 = this.searchSeat(r.coluna4);
            if (col4) {
              r.ocupada4 = false;
              if (col4.boarding_status) {
                r.embarcado4 = true;
              } else {
                r.embarcado4 = false;
              }
            }
          }
        }
      }
      if (this.mapa.andar_2) {
        for (let r of this.mapa.andar_2) {
          if (r.coluna1) {
            r.ocupada1 = true;
            let col1 = this.searchSeat(r.coluna1);
            if (col1) {
              r.ocupada1 = false;
              if (col1.boarding_status) {
                r.embarcado1 = true;
              } else {
                r.embarcado1 = false;
              }
            }
          }
          if (r.coluna2) {
            r.ocupada2 = true;
            let col2 = this.searchSeat(r.coluna2);
            if (col2) {
              r.ocupada2 = false;
              if (col2.boarding_status) {
                r.embarcado2 = true;
              } else {
                r.embarcado2 = false;
              }
            }
          }
          if (r.coluna3) {
            r.ocupada3 = true;
            let col3 = this.searchSeat(r.coluna3);
            if (col3) {
              r.ocupada3 = false;
              if (col3.boarding_status) {
                r.embarcado3 = true;
              } else {
                r.embarcado3 = false;
              }
            }
          }
          if (r.coluna4) {
            r.ocupada4 = true;
            let col4 = this.searchSeat(r.coluna4);
            if (col4) {
              r.ocupada4 = false;
              if (col4.boarding_status) {
                r.embarcado4 = true;
              } else {
                r.embarcado4 = false;
              }
            }
          }
        }
      }
    },

    searchSeat(seat) {
      for (let v of this.passengers) {
        if (v.seat == seat) {
          return v;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.passengers__ticket-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}

.passengers__ticket-seat {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
  font-weight: 600;
}

// .bus-layout {
//   border: 1px solid;
//   padding: 10px;
// }

.bg-cancel {
  background-color: #b30c00;
}

.bg-confirm {
  background-color: #20c600;
}

.passengers {
  display: grid;

  width: 90%;
  margin: auto;
}

.passengers__title {
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #000000;

  margin: 0;
}

.passengers__tips {
  font-size: 0.7rem;
  color: #7a8583;

  margin-bottom: 10px;
}

.passengers__ticket {
  background-color: #ffffff;

  margin-bottom: 5px;
}

.passengers--boarded {
  background-color: #f2fdf2;
  border: #1dc800 solid 1px;
}

.ticket__container {
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;

  height: 100%;
  width: 90%;
  margin: auto;
  padding: 4px 0;
}

.ticket__info {
  color: #7a8583;
  font-size: 14px;
  line-height: normal;
}

.ticket__icon {
  place-self: end;

  color: #7a8583;
  font-size: 30px;
}

.ticket__icon--boarded {
  color: #20c600;
}

.ticket__icon--effect {
  animation-name: slide;
  animation-delay: 2s;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-direction: alternate;

  @keyframes slide {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-20px);
    }
  }
}

.info--highlight {
  font-weight: 600;
  color: #040006;
}

.q-slide-item__content {
  height: 100%;
}

$tamanho-borda: 40px;
$distancia: 0.75rem;

%row {
  @extend %flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
}

%justify-space-between {
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

%pointer {
  cursor: pointer;
}

%flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.grid-legenda {
  display: grid;
  grid-template-columns: repeat(5, 1fr);

  @media (max-width: 425px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5px;
  }
}

.onibus {
  position: relative;
  background: white;
  padding: $distancia;
  margin-top: $distancia;
  width: 100%;
  border: 2px solid #969696;
  border-top-left-radius: $tamanho-borda;
  border-top-right-radius: $tamanho-borda;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: calc(100% + 6%);
    height: 5%;
    min-height: 38px;
    background: black;
    z-index: -1;
    border-radius: 14px;
    left: -3%;
  }

  &::after {
    bottom: 2%;
  }
}

.linha {
  @extend %row;
  @extend %justify-space-between;
  width: 100%;
  margin: $distancia/2 0;
}

.poltrona {
  transform: all ease 1s;
  user-select: none;
  display: block;
  position: relative;
  font-weight: bold;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;

  &[situacao="true"] {
    background: #efefef;
    pointer-events: none;

    &::after {
      content: "X";
      position: absolute;
      font-size: 27px;
      max-height: 100%;
      left: 33%;
      background: #efefef;
      color: #828282;
    }
  }

  &[embarcado="false"] {
    @extend %pointer;
    background: #ffe317;
    color: #fff;
  }

  &[embarcado="true"] {
    @extend %pointer;
    background: #20c600;
    color: #fff;
  }

  &.ESPACO_MULHER::before {
    content: "\1F380";
    color: #ef83bc;
    position: absolute;
    background-color: transparent;
    bottom: -20px;
    width: 3px;
    font-weight: bold;
    left: calc(50% - 11px);
    font-size: 22px;
    z-index: 1;
  }

  &:not([numero]) {
    visibility: hidden;
  }
}
</style>
